<script setup>
import GuideSetupTab from "../../components/GuideSetupTab.vue";
import IntegrationStripe from "../../../../stripe/IntegrationStripe.vue";
import StripeLinksGuide from "./guides/StripeLinksGuide.vue";
import StripeButtonGuide from "./guides/StripeButtonGuide.vue";
import StripeTableGuide from "./guides/StripeTableGuide.vue";
import UniversalCheckoutGuide from "../../guides/UniversalCheckoutGuide.vue";

const props = defineProps({
    programId: {
        type: Number,
        required: true
    },
    config: {
        type: Object,
        default: null
    },
    programType: {
        type: String
    }
});

const stripeSlotTabs = [
    { slotName: 'links', tabTitle: 'Payment Links' },
    { slotName: 'table', tabTitle: 'Pricing Table' },
    { slotName: 'button', tabTitle: 'Buy Button' },
    { slotName: 'checkout', tabTitle: 'Custom checkout' }
];
</script>

<template>
    <guide-setup-tab :slot-tabs="stripeSlotTabs">
        <template #head>

            <div class="space-y-2">
                <h3 class="font-semibold text-md">
                    1. Connect your Stripe account
                </h3>
                <div class="text-sm space-y-2">
                    <p>Link your Stripe account to Partnero. This allows us to track sales and attribute them to referred customers accurately.</p>
                </div>
                <div v-if="config">
                    <integration-stripe
                        type="button"
                        :program-id="programId"
                        :integrations-config="config"
                        :sync-customers-available="programType === 'refer_a_friend'"
                    />
                </div>
            </div>

            <div class="space-y-2">
                <h3 class="font-semibold text-md">
                    2. Select your preferred Stripe tracking method
                </h3>
                <div class="text-sm space-y-2">
                    <p>Choose the example that best matches your Stripe integration to correctly identify purchases made by referred customers.</p>
                </div>
            </div>

        </template>

        <template #links >
            <stripe-links-guide :program-type="programType" />
        </template>

        <template #table>
            <stripe-table-guide :program-type="programType" />
        </template>

        <template #button>
            <stripe-button-guide :program-type="programType" />
        </template>

        <template #checkout>
            <universal-checkout-guide :program-type="programType" />
        </template>

    </guide-setup-tab>
</template>

